/* eslint-disable camelcase */
/* eslint-disable no-console */
/* global SnapshotAjax, snapshot_messages */

import Helpers from '../../helpers';
import Backup from '../backup';

const ExportUI = {
	init() {
		this.listenSnapshotExport();
	},

	/**
	 * Listens to the `snapshot-export` custom event.
	 */
	listenSnapshotExport() {
		document.addEventListener( 'snapshot-export', ( evt ) => {
			const snapshotRow = document.querySelector( `tr[data-backup_id="${ evt.detail.snapshot_id }"]` );
			snapshotRow.classList.add( 'is-exporting' );
			const process = evt.detail.export_process;

			const exportProgress = document.querySelector( '.snapshot-export--progress__bar__wrap' );
			if ( exportProgress.classList.contains( 'd-none' ) ) {
				if ( 'files' === evt.detail.export_type ) {
					exportProgress.querySelector( '.snapshot-backup--export' ).classList.add( 'is-exporting' );
					exportProgress.querySelector( '.snapshot-backup--export' ).classList.add( 'snapshot-export--files' );
				}

				if ( 'database' === evt.detail.export_type ) {
					if ( ! exportProgress.querySelector( '.snapshot-backup--export' ).classList.contains( 'is-exporting' ) ) {
						exportProgress.querySelector( '.snapshot-backup--export' ).classList.add( 'is-exporting' );
					}
					exportProgress.querySelector( '.snapshot-backup--export' ).classList.add( 'snapshot-export--database' );
				}

				exportProgress.classList.remove( 'd-none' );
			}

			exportProgress.querySelector( '.progressbar-status' ).style.width = '5%';
			const exportRequest = setInterval( () => {
				const fd = new FormData();
				fd.append( 'action', 'snapshot-check_export_status' );
				fd.append( 'snapshot_id', evt.detail.snapshot_id );
				fd.append( 'export_id', evt.detail.export_id );
				fd.append( 'export_type', evt.detail.export_type );
				fd.append( 'export_status', evt.detail.export_status );
				fd.append( 'export_process', process );
				fd.append( '_wpnonce', document.querySelector( '#_wpnonce-export-backup' ).value );

				const request = fetch( SnapshotAjax.ajaxurl, {
					method: 'POST',
					credentials: 'same-origin',
					body: fd
				} );

				request
					.then( ( response ) => response.json() )
					.then( ( result ) => {
						const status = result.data.api_response.export_status;
						fd.delete( 'export_status' );
						fd.append( 'export_status', status );

						if ( 'files_export_started' === status || 'database_export_started' === status ) {
							exportProgress.querySelector( '.snapshot-backup--export' ).classList.remove( 'step-0' );
							exportProgress.querySelector( '.progressbar-status' ).removeAttribute( 'style' );
						}

						if ( 'full_backup' !== evt.detail.export_type ) {
							if ( 'files_export_started' === status ) {
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.add( 'step-1' );
							}

							if ( 'database_export_started' === status ) {
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.remove( 'step-1' );
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.add( 'step-3' );
							}
						} else {
							if ( 'files_export_started' === status ) {
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.add( 'step-1' );
							}

							if ( 'database_export_started' === status ) {
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.remove( 'step-1' );
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.add( 'step-2' );
							}
						}

						if ( 'export_completed' === status ) {
							if ( exportProgress.querySelector( '.snapshot-backup--export' ).classList.contains( 'step-1' ) ) {
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.remove( 'step-1' );
							}

							if ( exportProgress.querySelector( '.snapshot-backup--export' ).classList.contains( 'step-2' ) ) {
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.remove( 'step-2' );
							}

							if ( exportProgress.querySelector( '.snapshot-backup--export' ).classList.contains( 'step-3' ) ) {
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.remove( 'step-3' );
							}

							exportProgress.querySelector( '.snapshot-backup--export' ).classList.add( 'step-4' );

							clearInterval( exportRequest );
							setTimeout( () => {
								exportProgress.classList.add( 'd-none' );
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.remove( 'snapshot-export--files' );
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.remove( 'snapshot-export--database' );
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.remove( 'is-exporting' );
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.remove( 'step-4' );
								exportProgress.querySelector( '.snapshot-backup--export' ).classList.add( 'step-0' );

								snapshotRow.classList.remove( 'is-exporting' );

								Helpers.Notice.open( {
									message: snapshot_messages.backup_export_download_ready,
									type: 'success',
									dismissible: true
								} );

								Backup.reload();
							}, 5000 );
						}
					} )
					.catch( ( err ) => {
						console.error( err );
						// Clear the interval to prevent from infinite requests.
						clearInterval( exportRequest );
					} );
			}, 5000 );
		} );
	}
};

export default ExportUI;
